cockpitApp.directive('menuTop', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/menu/top',
    controllerAs: 'menuTopCtrl',
    controller: 'menuTopController'
  };
});
